export default __webpack_public_path__ + "static/media/test-foto4.5e218d85.jpg";